import { lazy, Suspense, useState } from "react";
import { Smile, Loader2 } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";

// emoji-picker-react ships its own emoji dataset — keep it out of the main bundle until first use.
const EmojiPicker = lazy(() => import("emoji-picker-react"));

export function EmojiButton({ onPick, onClose, className }) {
  const [open, setOpen] = useState(false);
  const change = (o) => { setOpen(o); if (!o) onClose?.(); };
  return (
    <Popover open={open} onOpenChange={change}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={className}
          data-testid="chat-emoji-btn"
          title="Emoji"
          aria-label="Insert emoji"
        >
          <Smile className="h-5 w-5" />
        </button>
      </PopoverTrigger>
      <PopoverContent side="top" align="start" sideOffset={8} className="w-auto overflow-hidden rounded-2xl border-white/10 bg-bloq-s1 p-0 shadow-2xl" data-testid="emoji-picker-popover">
        <Suspense fallback={<div className="flex h-[380px] w-[320px] items-center justify-center text-bloq-muted"><Loader2 className="h-5 w-5 animate-spin" /></div>}>
          <EmojiPicker
            theme="dark"
            emojiStyle="native"
            lazyLoadEmojis
            width={320}
            height={380}
            skinTonesDisabled
            previewConfig={{ showPreview: false }}
            searchPlaceHolder="Search emoji"
            onEmojiClick={(e) => onPick(e.emoji)}
          />
        </Suspense>
      </PopoverContent>
    </Popover>
  );
}
